import { getConfig } from '@/auth'
import { post } from '@/api/saveData'

export default {
	data() {
		return {
			captchasURL: '',
			captchaId: '',
			captcha: '',
		}
	},
	created() { },
	methods: {
		getCaptcha: function () {
			post(getConfig().captchas, {})
				.then(x => {
					this.captchaId = x.data.id
					this.captchasURL = getConfig().captchas;
				})
		},
	}
}